module.exports = __webpack_public_path__ + "img/flowaccount.9ca96db5.svg";